import { Grid } from '@mui/material';
import { IProjectData } from '../type';
import ProjectCard from './project-card';

interface PropsType {
  projects: IProjectData[];
}

const ProjectGrid = ({ projects }: PropsType): JSX.Element => {
  return (
    <Grid container spacing={2}>
      {projects.map((project: IProjectData) => {
        return (
          <Grid item xs={12} md={6} lg={6} xl={4} key={project.id}>
            <ProjectCard projectData={project} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProjectGrid;
